(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[4495],{

/***/ 19151:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/job-offers/[id]/[slug]",
      function () {
        return __webpack_require__(58032);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 84110:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "y": function() { return /* reexport safe */ _useFeatureFlag__WEBPACK_IMPORTED_MODULE_0__.y; }
/* harmony export */ });
/* harmony import */ var _useFeatureFlag__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(92552);



/***/ }),

/***/ 92552:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "y": function() { return /* binding */ useFeatureFlag; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(98788);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(22970);
/* harmony import */ var context_logged_user_loggeduser_context__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(23357);
/* harmony import */ var flagsmith_react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(98861);
/* harmony import */ var flagsmith_react__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(flagsmith_react__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(2784);





// Hook.
// -----------------------------------------------------------------------------
var useFeatureFlag = function(feature) {
    // Hooks.
    // ---------------------------------------------------------------------------
    var flags = (0,flagsmith_react__WEBPACK_IMPORTED_MODULE_1__.useFlags)([
        feature
    ]);
    var flagsmith = (0,flagsmith_react__WEBPACK_IMPORTED_MODULE_1__.useFlagsmith)();
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(!flagsmith.identity), isLoading = ref[0], setIsLoading = ref[1];
    // TODO: We should work with a Manfredite domain object her at some point
    var user = (0,react__WEBPACK_IMPORTED_MODULE_2__.useContext)(context_logged_user_loggeduser_context__WEBPACK_IMPORTED_MODULE_0__/* .LoggedUserContext */ .Vi).user;
    // Functions.
    // ---------------------------------------------------------------------------
    var identify = (0,react__WEBPACK_IMPORTED_MODULE_2__.useCallback)(/*#__PURE__*/ (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(function() {
        var email;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_4__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    if (!(flagsmith.initialised && !flagsmith.identity && user && user.email)) return [
                        3,
                        2
                    ];
                    email = user.email;
                    return [
                        4,
                        flagsmith.identify(email, {
                            email: email,
                            manfrediteId: user.id || null
                        })
                    ];
                case 1:
                    _state.sent();
                    _state.label = 2;
                case 2:
                    return [
                        2
                    ];
            }
        });
    }), [
        flagsmith,
        user
    ]);
    // Effects.
    // ---------------------------------------------------------------------------
    (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(function() {
        identify();
    }, [
        identify
    ]);
    (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(function() {
        if (flagsmith.initialised) {
            setIsLoading(false);
        }
    }, [
        flagsmith.identity,
        flagsmith.initialised
    ]);
    // Return
    // ---------------------------------------------------------------------------
    return {
        isEnabled: flags[feature].enabled,
        isLoading: isLoading,
        getAllTraits: flagsmith.getAllTraits,
        getTrait: flagsmith.getTrait,
        setTrait: flagsmith.setTrait
    };
};


/***/ }),

/***/ 56002:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "N": function() { return /* reexport */ usePageTrack; }
});

// EXTERNAL MODULE: ./context/logged-user/loggeduser.context.tsx
var loggeduser_context = __webpack_require__(23357);
// EXTERNAL MODULE: ./hooks/useFeatureFlag/index.ts
var useFeatureFlag = __webpack_require__(84110);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ./services/service.event-tracking.ts + 1 modules
var service_event_tracking = __webpack_require__(27862);
;// CONCATENATED MODULE: ./hooks/usePageTrack/usePageTrack.ts




var usePageTrack = function(event) {
    var ref = (0,react.useContext)(loggeduser_context/* LoggedUserContext */.Vi), user = ref.user, loadingUser = ref.loadingUser;
    var ref1 = (0,useFeatureFlag/* useFeatureFlag */.y)("talent_manfredite_profile_page_tracking"), isEnabled = ref1.isEnabled, isLoadingFeatureFlag = ref1.isLoading;
    var alreadySent = (0,react.useRef)(false);
    (0,react.useEffect)(function() {
        // Still loading feature flag values
        if (isLoadingFeatureFlag) {
            return;
        }
        // If event is "Public Profile - Page Loaded" and feature flag is disabled, do not track
        var isPublicProfileTrackDisabled = !isLoadingFeatureFlag && !isEnabled && event === "Public Profile - Page Loaded";
        if (isPublicProfileTrackDisabled) {
            return;
        }
        // When user info (if any) is already loaded and event is not tracked yet => Track it
        if (!alreadySent.current) {
            var urlParams = new URLSearchParams(window.location.search);
            // Identify user with campaign traits if user is logged in and campaign exists
            if (urlParams.get("utm_campaign")) {
                identifyUserWithCampaign(urlParams);
            }
            service_event_tracking/* default.page */.Z.page(event, {
                userId: (user === null || user === void 0 ? void 0 : user.id) ? "userId-".concat(user.id) : undefined
            });
            alreadySent.current = true;
        }
    }, [
        loadingUser,
        event,
        user === null || user === void 0 ? void 0 : user.id,
        isLoadingFeatureFlag,
        isEnabled
    ]);
};
function identifyUserWithCampaign(urlParams) {
    var ref, ref1, ref2, ref3, ref4, ref5;
    service_event_tracking/* default.identifyAnonymous */.Z.identifyAnonymous({
        "campaign.name": ((ref = urlParams.get("utm_campaign")) === null || ref === void 0 ? void 0 : ref.toLowerCase()) || undefined,
        "campaign.source": ((ref1 = urlParams.get("utm_source")) === null || ref1 === void 0 ? void 0 : ref1.toLowerCase()) || undefined,
        "campaign.medium": ((ref2 = urlParams.get("utm_medium")) === null || ref2 === void 0 ? void 0 : ref2.toLowerCase()) || undefined,
        "campaign.term": ((ref3 = urlParams.get("utm_term")) === null || ref3 === void 0 ? void 0 : ref3.toLowerCase()) || undefined,
        "campaign.content": ((ref4 = urlParams.get("utm_content")) === null || ref4 === void 0 ? void 0 : ref4.toLowerCase()) || undefined,
        "campaign.id": ((ref5 = urlParams.get("utm_id")) === null || ref5 === void 0 ? void 0 : ref5.toLowerCase()) || undefined
    });
}

;// CONCATENATED MODULE: ./hooks/usePageTrack/index.ts



/***/ }),

/***/ 58032:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "__N_SSG": function() { return /* binding */ __N_SSG; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(92228);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(52322);
/* harmony import */ var components_jobOffer_JobOfferComponent__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(10306);
/* harmony import */ var components_jobOffer_JobOfferPageHead__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(94125);
/* harmony import */ var context_wip_features_wip_features_context__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(84245);
/* harmony import */ var hooks_usePageTrack__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(56002);
/* harmony import */ var next_dist_client_router__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(93642);
/* harmony import */ var next_dist_client_router__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(next_dist_client_router__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(2784);
/* harmony import */ var services_ui_offer_service__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(58630);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(40286);
/* harmony import */ var utils_app_urls__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(62177);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    #freshworks-container iframe {\n      bottom: 90px !important;\n    }\n  "
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}










var OfferPage = function(param) {
    var offer = param.offer, slug = param.slug;
    var router = (0,next_dist_client_router__WEBPACK_IMPORTED_MODULE_6__.useRouter)();
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_7__.useState)(""), origin = ref[0], setOrigin = ref[1];
    (0,hooks_usePageTrack__WEBPACK_IMPORTED_MODULE_5__/* .usePageTrack */ .N)("Website - Page Loaded");
    (0,react__WEBPACK_IMPORTED_MODULE_7__.useEffect)(function() {
        setOrigin(window.location.origin);
    }, []);
    (0,react__WEBPACK_IMPORTED_MODULE_7__.useEffect)(function() {
        var offerSlug = offer.slug;
        if (slug && shouldRedirectToSlug(slug, offerSlug)) {
            router.push("".concat((0,utils_app_urls__WEBPACK_IMPORTED_MODULE_9__/* .getAppUrl */ .TI)(utils_app_urls__WEBPACK_IMPORTED_MODULE_9__/* .APP_URLS.jobOffer */ .uu.jobOffer, router.locale)).concat((0,services_ui_offer_service__WEBPACK_IMPORTED_MODULE_8__/* .getOfferUrl */ .Jf)(offer, router.locale)));
        }
    }, []);
    var JobOfferGlobalStyles = (0,styled_components__WEBPACK_IMPORTED_MODULE_10__/* .createGlobalStyle */ .vJ)(_templateObject());
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(JobOfferGlobalStyles, {}),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(components_jobOffer_JobOfferPageHead__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                url: utils_app_urls__WEBPACK_IMPORTED_MODULE_9__/* .APP_URLS.jobOffer */ .uu.jobOffer,
                offer: offer,
                locale: router.locale,
                origin: origin
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(context_wip_features_wip_features_context__WEBPACK_IMPORTED_MODULE_4__/* ["default"].Provider */ .Z.Provider, {
                value: false,
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(components_jobOffer_JobOfferComponent__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                    offer: offer,
                    origin: origin
                })
            })
        ]
    });
};
var __N_SSG = true;
/* harmony default export */ __webpack_exports__["default"] = (OfferPage);
function shouldRedirectToSlug(slugParam, offerSlug) {
    return !slugParam || slugParam !== offerSlug;
}


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [7482,6129,3467,6577,411,625,4882,1391,9774,2888,179], function() { return __webpack_exec__(19151); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);